(function () {
    'use strict';

    var module = angular.module('imApp');

    module.component('purchaseMenu', {
        templateUrl: 'views/components/views/purchaseMenu/purchaseMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', function (stateService) {
            var vm = this;

            vm.model = {
                name: stateService.getCurrentName()
            };
        }]
    });
})();